import backOffice from "./modules/back-office/general.js";
import storeBack from "./modules/back-office/StoreManage.js";

import fetchMessVehicleBack from "./fetch-modules/back-office/vehicle";
import fetchMessAddonBack from "./fetch-modules/back-office/Addon";

import fetchFoodPromotionBack from "./fetch-modules/back-office/Promotion";
import fetchFoodSetAppBack from "./fetch-modules/back-office/SetApp";
import fetchFoodRateBack from "./fetch-modules/back-office/Transfer/Rate";
import fetchFoodExtraBack from "./fetch-modules/back-office/Transfer/Extra";
import fetchFoodZoneBack from "./fetch-modules/back-office/Transfer/Zone";

import fetchOrderDetailBack from "./fetch-modules/back-office/Order/OrderDetail";
import fetchOrderListBack from "./fetch-modules/back-office/Order/OrderList.js";
import fetchProductApproveBack from "./fetch-modules/back-office/Product/ProductApprove";
import fetchStoreApproveBack from "./fetch-modules/back-office/Store/StoreApprove";
import fetchPackageBack from "./fetch-modules/back-office/Package.js";
import fetchStoreBack from "./fetch-modules/back-office/Store/Store.js";
import fetchRoleBack from "./fetch-modules/back-office/Role.js";
import fetchUserBack from "./fetch-modules/back-office/User.js";
import fetchProvinceBack from "./fetch-modules/back-office/Province.js";
import fetchCustomerBack from "./fetch-modules/back-office/Customer.js";

import fetchProductListBack from "./fetch-modules/back-office/Product/ProductList.js";
import fetchProductTypeBack from "./fetch-modules/back-office/Product/ProductType.js";

import fetchRiderListBack from "./fetch-modules/back-office/Rider/Rider.js";
import fetchDefaultRider from "./fetch-modules/back-office/Rider/DefaultValues.js";
import fetchCashRider from "./fetch-modules/back-office/Rider/Cash.js";
import fetchWeserveBank from "./fetch-modules/back-office/Rider/WeserveBank.js";
import fetchRiderCommission from "./fetch-modules/back-office/Rider/Commission.js";

import fetchReportFood from "./fetch-modules/back-office/Report/Food.js";
import fetchReportFree from "./fetch-modules/back-office/Report/Free.js";
import fetchReportMessenger from "./fetch-modules/back-office/Report/Messenger.js";
import fetchReportDashboard from "./fetch-modules/back-office/Report/OrderReport.js";
import fetchSaleStoreReport from "./fetch-modules/back-office/Report/SaleStoreReport.js";
import fetchStorePaymentReport from "./fetch-modules/back-office/Report/StorePaymentReport.js";
import fetchRiderReport from "./fetch-modules/back-office/Report/RiderReport.js";
import fetchSaleMessengerReport from "./fetch-modules/back-office/Report/SaleMessengerReport.js";
import fetchPromotionReport from "./fetch-modules/back-office/Report/PromotionReport.js";
import fetchCustomerReport from "./fetch-modules/back-office/Report/CustomerReport.js";
import fetchExtraCreditReport from "./fetch-modules/back-office/Report/ExtraCreditReport.js";
import fetchWellnessReport from "./fetch-modules/back-office/Report/WellnessReport.js";
import fetchMerchantStoreProfit from "./fetch-modules/back-office/Report/StoreProfit.js";
import fetchCommission from "./fetch-modules/back-office/CommissionAPI";
import fetchDineIn from "./fetch-modules/back-office/DineIn.js";
import fetchAddcredit from "./fetch-modules/back-office/AddCredit";

import cashRequest from "./fetch-modules/back-office/RequestCash";
import fetchGeneral from "./fetch-modules/General.js";
// version ^1.9.5
import advertising from "./fetch-modules/back-office/Advertising.js";
import report from "./fetch-modules/back-office/Report.js";
import product from "./fetch-modules/back-office/Product.js";
import campaigns from "./fetch-modules/back-office/Campaigns.js";
import crypto from "./fetch-modules/back-office/Crypto.js";
import distances from "./fetch-modules/back-office/Transfer/Distance.js";
import StoreTransferConfig from "./fetch-modules/back-office/Transfer/StoreTransferConfig.js";
import StoreTransferBatch from "./fetch-modules/back-office/Transfer/StoreTransferBatch.js";
import StoreTransferItem from "./fetch-modules/back-office/Transfer/StoreTransferItem.js";
import tierBenefits from "./fetch-modules/back-office/TierBenefits.js";
import pointmanage from "./fetch-modules/back-office/PointManage.js";
import banklist from "./fetch-modules/back-office/Bank";
import invoice from "./fetch-modules/back-office/Manager/invoice.js";
import fetchWithdraw from "./fetch-modules/back-office/CommissionWithdraw";
import Business from "./fetch-modules/back-office/Business.js";
import fetchAddonFood from "./fetch-modules/back-office/Food/Addon.js";

import hotel from "./fetch-modules/back-office/Hotel.js";
import hotelReport from "./fetch-modules/back-office/Report/HotelServiceReport.js";

const modules = {
  invoice,
  crypto,
  product,
  pointmanage,
  tierBenefits,
  distances,
  StoreTransferConfig,
  StoreTransferBatch,
  StoreTransferItem,
  campaigns,
  fetchCustomerReport,
  fetchGeneral,
  fetchExtraCreditReport,
  fetchPromotionReport,
  fetchSaleMessengerReport,
  fetchStorePaymentReport,
  fetchRiderReport,
  fetchSaleStoreReport,
  fetchMerchantStoreProfit,
  fetchReportDashboard,
  fetchReportMessenger,
  fetchReportFood,
  fetchReportFree,
  fetchFoodPromotionBack,
  fetchFoodSetAppBack,
  fetchFoodRateBack,
  fetchFoodExtraBack,
  fetchMessAddonBack,
  fetchMessVehicleBack,
  fetchFoodZoneBack,
  fetchOrderDetailBack,
  fetchProductApproveBack,
  fetchStoreApproveBack,
  fetchOrderListBack,
  backOffice,
  fetchUserBack,
  fetchProvinceBack,
  fetchCustomerBack,
  storeBack,
  fetchRoleBack,
  fetchStoreBack,
  fetchPackageBack,
  fetchProductTypeBack,
  fetchProductListBack,
  fetchCommission,
  banklist,
  fetchWithdraw,
  fetchDineIn,
  fetchAddcredit,
  cashRequest,
  Business,
  //RIDER
  fetchRiderListBack,
  fetchDefaultRider,
  fetchCashRider,
  fetchWeserveBank,
  fetchRiderCommission,
  //version ^1.9.5
  advertising,
  report,

  // Wellness Report
  fetchWellnessReport,
  fetchAddonFood,

  hotel,
  hotelReport
};

export default modules;
